<script lang="ts">

export default {
  name: "BaseAlert",
  props: {
    visible: { type: Boolean, default: false },
    type: {
      type: String,
      default: "info",
      validator: value => ["info", "success", "warning", "danger", "secondary"].includes(value)
    },
    title: { type: String, required: true },
    message: { type: String, required: true },
    showButton: { type: Boolean, default: false },
    buttonText: { type: String, default: "Voltar à listagem" }
  },
  computed: {
    iconClass() {
      const icons = {
        info: "fas fa-info-circle",
        success: "fas fa-check-circle",
        warning: "fas fa-exclamation-triangle",
        danger: "fas fa-times-circle",
        secondary: "fas fa-info"
      };
      return icons[this.type] || icons.info;
    }
  }
}
</script>

<template>
  <div v-if="visible" :class="['alert', `alert-${type}`]">
    <div class="alert-content">
      <div class="alert-content--text">
        <i :class="iconClass"></i>
        <slot name="content">
          <p class="mb-0 alert-text">
            <b>{{ title }}</b> {{ message }}
          </p>
        </slot>
      </div>

      <div class="alert-content--button" v-if="showButton">
        <b-button :class="['review-button', `btn-${type}`]" :variant="type" @click="$emit('action')">
          <i class="fas fa-arrow-left icon-left"></i> {{ buttonText }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.alert {
  border-radius: 10px;
  display: flex;
  padding: 24px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  flex-wrap: wrap;
  width: 100%;
}

.alert-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  flex-wrap: wrap;
}

.alert-content--text {
  display: flex;
  align-items: center;
  gap: 16px;
}

.alert-info {
  background: var(--Blue-50, #EFF6FF);
  color: var(--Blue-600, #2469EE);
  border-color: transparent;
}

.alert-success {
  background: var(--Primary-50, #EBFEF6);
  color: var(--Primary-600, #00B07F);
}

.alert-warning {
  background: var(--Yellow-50, #FEFCE8);
  color: var(--Yellow-600, #C68708);
}

.alert-danger {
  background: var(--Red-50, #FFF3ED);
  color: var(--Red-500, #FF4820);
}

.alert-secondary {
  background: var(--Gray-10, #F0F2F5);
  color: var(--Old-800, #003B36);
}

.review-button {
  border-radius: 10px;
  background: var(--Blue-600, #2469EE);
  height: 48px;
  padding: 0px 16px;
  border-color: var(--Blue-600, #2469EE);
}

.btn-info {
  background: var(--Blue-600, #2469EE);
  border-color: var(--Blue-600, #2469EE);
  color: white;
}
.btn-success {
  background: var(--Primary-600, #00B07F);
  border-color: var(--Primary-600, #00B07F);
  color: white;
}
.btn-warning {
  background: var(--Yellow-600, #C68708);
  border-color: var(--Yellow-600, #C68708);
  color: white;
}
.btn-danger {
  background: var(--Red-500, #FF4820);
  border-color: var(--Red-500, #FF4820);
  color: white;
}
.btn-secondary {
  background: var(--Old-800, #003B36);
  border-color: var(--Old-800, #003B36);
  color: white;
}
.alert-text {
  font-size: 15px;
  line-height: 1.5;
}
.icon-left {
  margin-right: 10px;
}
</style>
